import React, {
  useEffect,
  useState,
  useContext,
  useRef,
  useCallback,
} from "react";
import { purchaseService } from "../services/purchase.service";
import { accountService } from "../services/accountService";
import TextareaAutosize from '@mui/material/TextareaAutosize';

import LogicContext from "../Context/LogicContext";
import { NumericFormat } from 'react-number-format';
import {
  GetAddPurchaseReceive, ResetAddPurchaseReceive, SetAddPurchaseReceive} from "../store/purchaseReceiveAtom";
import CancelIcon from '@mui/icons-material/Cancel';

import { useForm, Controller } from "react-hook-form";
import moment from "moment";

import { useNavigate } from "react-router-dom";
import GeneralModal from "../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import { useSearchParams } from 'react-router-dom';
import { TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { Table } from "react-bootstrap";
import StockAdjustmentWarehouse from "./stock-adjustment/StockAdjustmentWarehouse";
import { GetStockOpeningList, SetStockOpeningList } from "../store/stockOpeningAtom";
import { stockOpeningService } from "../services/stockOpening.service";




function AddPurchaseReceivePage() {
  const getStockData = GetStockOpeningList();
  const setStockData  = SetStockOpeningList();
   
  
  const purchaseReceive = GetAddPurchaseReceive();
  const setAddPurchaseList = SetAddPurchaseReceive();
  const resetPendingPurchaseReceive = ResetAddPurchaseReceive();
  const navigate = useNavigate();
  const myPromiseModal = createModal(GeneralModal);
  const { register, setValue, getValues, handleSubmit, control, reset, formState: { errors } } = useForm();
  const logicContext = useContext(LogicContext);
  const [searchParams, setSearchParams] = useSearchParams();
  const purchaseOrderIdModify = searchParams.get('purchase_order_ref');
  const customOption = searchParams.get('option');



  
  useEffect(() => {

    return () => {
      resetPendingPurchaseReceive();
    };

  }, []);


  const getStockListFromAPI = useCallback(async () => {
     
    try {
      const response = await stockOpeningService.stockOpeningList();
      
      if ( response?.data !== undefined) {
        setStockData(response.data);
      }
    } catch (err) {
        console.error(err);
    }
   
  }, [setStockData]);

  if(!getStockData?.warehouse?.length){
    getStockListFromAPI(); // Just calling this in order to get Warehouse list

  }




  useEffect(() => {
    console.log('purchaseReceive ', purchaseReceive);


    try {
      if (purchaseReceive?.list?.length > 0) {
        setValue('Purchase_Order_Ref_No', purchaseReceive.Purchase_Order_Ref_No);
        setValue('warehouse_id', purchaseReceive.warehouse_id);

      }
      
    } catch (error) {
      logicContext.showToast('Something went wrong', 'danger')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onWarehouseSelect = (warehouse) => {
    setValue('warehouse_id', warehouse.warehouse_id);
  };





  const onSubmit = async (option) => {

    //  validate
    if (purchaseReceive?.list?.length === 0) {
      logicContext.showToast("empty list cannot be submitted!", "error");
      return navigate(-1);
    }



    await myPromiseModal({
      title: "Confirmation", body: " Do you want to save this record?",
      showInput:false, placeHolder:''}).then((res) => {
      if (res.decision === true) {
        var option = customOption;
        if(purchaseOrderIdModify !== null){
          option = 3;
        }
        const newData = getValues();
        var tempStringList = purchaseReceive.list?.map((item) => {
     

          let temp = `<a> <item_id>${item.Item_Id} 
           </item_id> <item_quantity>${item.Remaining_Quantity } </item_quantity> </a>`;
          return temp;
        });

        purchaseService.submitPurchaseReceive({ ...newData, option, xml_string_item: `<root>${tempStringList} </root>` }).then((res) => {
          const response = logicContext.httpResponseManager(res.data?.[0] || res.data?.result_status?.[0]);

          if (response.message_id === 1) {
             navigate(-1);
            logicContext.showToast(response.message_text || 'Submission successful!', 'success');
          } else {
            logicContext.showToast(response.message_text || 'Failed to save', 'error');
          }
        
        });
      }
    }).catch((err) => {
        logicContext.showToast("error submitting form, please try again", "error");
      });
  };



  function expectedDeliveryDate() {
    let defaultDate = moment(Date.now()).format("YYYY-MM-DD");
  
    return (
      <input
        defaultValue={defaultDate}
        key={defaultDate}
        className="flex-1 px-3 py-2 bg-white border border-gray-300 rounded-md outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
        type="date"
        {...register("Purchase_Receive_Date", {
          required: "purchase receive date is required",
        })}
      />
    );
  }


  async function exitPage() {
    await myPromiseModal({  title: "Exit page", body: "Are you sure you want to leave this page?",
      showInput:false, placeHolder:''}).then((res) => {
      if (res.decision === true) {
        navigate(-1)
      }
    })

  }


  const onRemainingQtyChange = async(qty, index) => {
    const newQty = parseFloat(qty)
      const currentItem = purchaseReceive.list[index];
      const newList = purchaseReceive.list?.map((item) => {
        if (item.Item_Id === currentItem.Item_Id) {
          return { ...item, Remaining_Quantity: parseFloat(newQty) }
        } else {
          return item;
        }

      });
      let newData = { Purchase_Order_Ref_No: purchaseReceive?.Purchase_Order_Ref_No, list: newList }
      setAddPurchaseList(newData);
  }


  function deleteItemFromTable(removedItem) {
    const newList = purchaseReceive.list.filter((item) => item.Item_Id !== removedItem.Item_Id);
    let newData = { Purchase_Order_Ref_No: purchaseReceive?.Purchase_Order_Ref_No, list: newList }
    setAddPurchaseList(newData);
  }


  function orderedQuantity() {
    let result = 0;
    purchaseReceive?.list?.forEach(element => {
      result += element.Purcahse_Order_Quantity;
    });
    return result;
  }


  function remainingQty() {
    let orderedQty = 0;
    let received = 0;
    purchaseReceive?.list?.forEach(element => {
      orderedQty += element.Purcahse_Order_Quantity;
      received += element.Purcahse_Receive_Quantity;
    });

    let result = orderedQty - received ;
    return result;
  }


  function receivedQty() {
    let result = 0;
    purchaseReceive?.list?.forEach(element => {
      result += element.Purcahse_Receive_Quantity;
    });
    return result;
  }


  function receivingQty() {
    let result = 0;
    purchaseReceive?.list?.forEach(element => {
      result += element.Remaining_Quantity;
    });
    return result;
  }



  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 py-8">
      <form onSubmit={handleSubmit(onSubmit)} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Container */}
        <div className="bg-white shadow-xl rounded-2xl overflow-hidden">
          
          {/* Header Section */}
          <div className="bg-gradient-to-r from-blue-600 to-indigo-600 px-6 py-5">
            <div className="flex justify-between items-center">
              <div>
                <h1 className="text-2xl font-bold text-white">Purchase Receive</h1>
                <p className="text-blue-100 text-sm mt-1">Create new purchase receive record</p>
              </div>
              <button
                type="button"
                onClick={() => exitPage()}
                className="p-2 hover:bg-white/10 rounded-full transition-colors"
              >
                <CancelIcon className="text-white" fontSize="large" />
              </button>
            </div>
          </div>

          {/* Form Content */}
          <div className="p-8">
            
           {/* Form Fields Section */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
            
            {/* Purchase Receive Number */}
            <div className="bg-gradient-to-r from-blue-50 to-blue-50 border border-blue-200 rounded-lg p-4">
              <div className="flex items-center space-x-3">
                <span className="text-sm font-semibold text-red-700 whitespace-nowrap">
                  Purchase Receive #
                </span>
                <input
                  readOnly={true}
                  placeholder="Auto generated"
                  type="text"
                  className="flex-1 bg-transparent outline-none text-gray-600 placeholder-gray-400"
                />
              </div>
            </div>

        {/* Receive Date */}
        <div className="bg-gradient-to-r from-blue-50 to-blue-50 border border-blue-200 rounded-lg p-4">
          <div className="flex items-center space-x-3">
            <span className="text-sm font-semibold text-red-700 whitespace-nowrap">
              Receive Date
            </span>
            {expectedDeliveryDate()}
          </div>
        </div>

        {/* Warehouse Selection - Taking up full width or half depending on preference */}
        <div className="md:col-span-2"> 
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            Warehouse <span className="text-red-500">*</span>
          </label>
          <StockAdjustmentWarehouse
            defaultVal={{ label: purchaseReceive?.warehouse_name }}
            list={getStockData?.warehouse || []}
            onWareHouseSelect={onWarehouseSelect}
            {...register('warehouse_id', { required: 'Warehouse is required' })}
          />
          {errors.warehouse_id && (
            <p className="text-red-600 text-sm mt-2 flex items-center">
              <span className="mr-1">⚠</span>
              {errors.warehouse_id.message}
            </p>
          )}
        </div>

      </div>
            {/* Items Table Section */}
            <div className="mb-8">
              <h2 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                <span className="w-1 h-6 bg-blue-600 rounded mr-3"></span>
                Items to Receive
              </h2>
              
              <div className="border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                <TableContainer>
                  <Table sx={{ minWidth: 650 }} aria-label="purchase receive table">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#F8FAFC' }}>
                        <TableCell className="font-semibold text-gray-700 py-4">
                          Items and Description
                        </TableCell>
                        <TableCell className="font-semibold text-gray-700 py-4">
                          Quantity Ordered
                        </TableCell>
                        <TableCell className="font-semibold text-gray-700 py-4">
                          Quantity Received
                        </TableCell>
                        <TableCell className="font-semibold text-gray-700 py-4">
                          Quantity to Receive
                        </TableCell>
                        <TableCell className="font-semibold text-gray-700 py-4"></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {purchaseReceive.list?.length === 0 ? (
                        <TableRow>
                          <TableCell colSpan={5} className="text-center py-12">
                            <div className="text-gray-400">
                              <p className="text-lg font-medium">No items added yet</p>
                              <p className="text-sm mt-1">Add items to create a purchase receive</p>
                            </div>
                          </TableCell>
                        </TableRow>
                      ) : (
                        purchaseReceive.list?.map((item, i) => (
                          <TableRow 
                            key={i} 
                            className="hover:bg-blue-50/50 transition-colors"
                            sx={{ '&:last-child td': { borderBottom: 0 } }}
                          >
                            <TableCell className="py-4">
                              <span className="font-bold text-gray-800">{item?.Item_Name}</span>
                            </TableCell>
                            <TableCell className="py-4">
                              <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
                                {item?.Purcahse_Order_Quantity}
                              </span>
                            </TableCell>
                            <TableCell className="py-4">
                              <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-green-100 text-green-800">
                                {item?.Purcahse_Receive_Quantity}
                              </span>
                            </TableCell>
                            <TableCell className="py-4">
                              <NumericFormat
                                value={item?.Remaining_Quantity}
                                className="w-32 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                                thousandSeparator=","
                                decimalSeparator="."
                                allowedDecimalSeparators={['%']}
                                onValueChange={(values) => {
                                  onRemainingQtyChange(parseFloat(Number(values.value)), i);
                                }}
                              />
                            </TableCell>
                            <TableCell align="right" className="py-4">
                              <button
                                type="button"
                                onClick={() => deleteItemFromTable(item)}
                                className="p-2 hover:bg-red-50 rounded-full transition-colors group"
                              >
                                <DeleteIcon className="text-red-500 group-hover:text-red-700 transition-colors" />
                              </button>
                            </TableCell>
                          </TableRow>
                        ))
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </div>

            {/* Summary Section */}
            <div className="mb-8">
              <h2 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                <span className="w-1 h-6 bg-blue-600 rounded mr-3"></span>
                Summary
              </h2>
              
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                
                <div className="bg-gradient-to-br from-blue-50 to-blue-100 border border-blue-200 rounded-xl p-5">
                  <p className="text-sm font-medium text-blue-700 mb-1">Ordered Quantity</p>
                  <p className="text-3xl font-bold text-blue-900">{orderedQuantity()}</p>
                </div>

                <div className="bg-gradient-to-br from-yellow-50 to-yellow-100 border border-yellow-200 rounded-xl p-5">
                  <p className="text-sm font-medium text-yellow-700 mb-1">Total Remaining</p>
                  <p className="text-3xl font-bold text-yellow-900">{remainingQty()}</p>
                </div>

                <div className="bg-gradient-to-br from-green-50 to-green-100 border border-green-200 rounded-xl p-5">
                  <p className="text-sm font-medium text-green-700 mb-1">Received Quantity</p>
                  <p className="text-3xl font-bold text-green-900">{receivedQty()}</p>
                </div>

                <div className="bg-gradient-to-br from-purple-50 to-purple-100 border border-purple-200 rounded-xl p-5">
                  <p className="text-sm font-medium text-purple-700 mb-1">Receiving Quantity</p>
                  <p className="text-3xl font-bold text-purple-900">{receivingQty()}</p>
                </div>

              </div>
            </div>

            {/* Notes Section */}
            <div className="mb-8">
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Notes (Optional)
              </label>
              <TextareaAutosize
                aria-label="Purchase receive notes"
                minRows={1}
                placeholder="Add any additional notes or comments about this purchase receive..."
                className="w-full p-1 border border-gray-300 rounded-xl resize-none focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
              />
            </div>

            {/* Action Buttons */}
            <div className="flex justify-end items-center space-x-4 pt-6 border-t border-gray-200">
              <button
                type="button"
                onClick={() => exitPage()}
                className="px-8 py-3 border-2 border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 hover:border-gray-400 transition-all duration-200"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-8 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-medium rounded-lg hover:from-blue-700 hover:to-indigo-700 shadow-lg hover:shadow-xl transition-all duration-200 transform hover:-translate-y-0.5"
              >
                Save Purchase Receive
              </button>
            </div>

          </div>
        </div>
      </form>
    </div>
  );
}

export default AddPurchaseReceivePage;